import React, { useState } from 'react';

import { Col, Dropdown, Modal } from 'react-bootstrap';
import '../JobStageSummary.scss';
import Textfield from '../../../_common/Textfield/Textfield';
import { CustomButton } from '../../../_common/CustomButton/CustomButton';
import { useQuery } from '@apollo/client/react';
import { GET_WELL_HEADS_BY_STAGE_GROUP_ID } from '../../../../graphql/client/queries';
import { GetWellheadsByStageGroupId_getWellheadsByStageGroupId as StageWellheads } from '../../../../types/schemaTypes';
import { Loading } from '../../../_common/Loading/Loading';

interface StageSheetModalProps {
    showStageSheetModal: boolean;
    modalType: string;
    isPartial: boolean;
    stageSheetBoxId: number;
    stageSheetBox: string;
    sandTicketNumber?: string;
    sandTicket?: string;
    weight: number;
    handleOnClose: () => void;
    handleOnSave: (stageSheetBoxId: number, command: string, weightRemaining: number) => void;
    mutationLoading: boolean;
    mutationError: string | undefined;
}

const StageSheetModal = ({
    showStageSheetModal,
    modalType,
    isPartial,
    stageSheetBoxId,
    stageSheetBox,
    sandTicket,
    weight,
    sandTicketNumber,
    handleOnClose,
    handleOnSave,
    mutationLoading,
    mutationError,
}: StageSheetModalProps): React.ReactElement => {
    const [weightRemaining, setWeightRemaining] = useState(modalType === 'OOS' ? weight : 0);
    const [error, setError] = useState('');

    const onClickClose = () => {
        handleOnClose();
    };

    const onClickSave = () => {
        if (weightRemaining < 0) {
            setError('Please enter a valid Weight');
            return;
        }
        if (weightRemaining > weight) {
            setError(`Weight remanining must be less than or equal to ${weight}`);
            return;
        }
        handleOnSave(stageSheetBoxId, modalType, Number.isNaN(weightRemaining) ? 0 : weightRemaining);
    };

    const handleOnChangeWeightRemaining = weightRemainingVal => {
        setError('');
        setWeightRemaining(weightRemainingVal);
    };

    return (
        <Modal show={showStageSheetModal} onHide={onClickClose} dialogClassName="StageModal-Container">
            {mutationLoading && (
                <span className="AddStageModal-Loading">
                    <Loading />
                </span>
            )}

            <Modal.Header className="AddStageModal-Header">
                <Modal.Title className="AddStageModal-Header-Container">
                    <button className="material-icons AddStageModal-X-Button" onClick={onClickClose}>
                        close
                    </button>
                    {modalType === 'OOS' && <div className="AddStageModal-Title">Do Not Use Box</div>}
                    {modalType === 'empty' && <div className="AddStageModal-Title">Empty Box</div>}
                    {modalType === 'sandTicket' && (
                        <div className="AddStageModal-Title">Sand Ticket - {sandTicketNumber}</div>
                    )}
                    <div className="AddStageModal-Error">{mutationError}</div>
                    <div className="AddStageModal-Error">{error}</div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="AddStageModal-Body">
                {modalType === 'sandTicket' && (
                    <div className="StageSheet-SandTicket-Container">
                        <img src={sandTicket} className="StageSheet-SandTicket" />
                    </div>
                )}

                <Col md={10}>
                    {modalType === 'OOS' && (
                        <>
                            <div>Are you sure you want to put the box - {stageSheetBox} Out of Service?</div>
                            <div className="Textfield-InputTitle input-group-text StageSheetModal-Weight">
                                Weight Remaining
                            </div>
                            <input
                                type="number"
                                title="Weight Remaining"
                                className="AddStageNumber StageSheet-Modal-Input"
                                value={weightRemaining === 0 ? '' : weightRemaining}
                                onChange={element => handleOnChangeWeightRemaining(parseInt(element.target.value))}
                            />
                        </>
                    )}

                    {modalType === 'empty' && (
                        <div>
                            {isPartial ? (
                                <b>
                                    THIS WILL EMPTY THE BOX - {stageSheetBox} FULLY AND REMOVE THE BOX FROM INVENTORY
                                    AND PLACE IT IN THE EMPTY BOX INVENTORY
                                </b>
                            ) : (
                                <b>
                                    THIS WILL EMPTY THE ALLOCATED WEIGHT FOR BOX - {stageSheetBox} AND THE UNALLOCATED
                                    WEIGHT WILL SHOW UP ON THE DANCE FLOOR
                                </b>
                            )}
                        </div>
                    )}
                </Col>
            </Modal.Body>

            {modalType === 'sandTicket' ? (
                <Modal.Footer className="AddStageModal-Footer AddStageModal-Footer-Sm">
                    <CustomButton title="Close" onClick={onClickClose} />
                </Modal.Footer>
            ) : (
                <Modal.Footer className="AddStageModal-Footer">
                    <CustomButton title="Cancel" isBordered onClick={onClickClose} />
                    <CustomButton title="Continue" onClick={() => onClickSave()} />
                </Modal.Footer>
            )}
        </Modal>
    );
};

export default StageSheetModal;
